/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InvoiceTypeEnum = 0 | 1 | 2;

export const InvoiceTypeEnum = {
    NOT_SET: 0 as InvoiceTypeEnum,
    Debet: 1 as InvoiceTypeEnum,
    Credit: 2 as InvoiceTypeEnum
};

